import React, { useState, useEffect } from 'react'
import { useLocation, useHistory } from 'react-router-dom'
import { scenes } from './scenes'
import { map_data }         from './map_data'
import { nanoid }           from 'nanoid'

import JSZip from 'jszip'

const SceneContext = React.createContext()

let state, setState, location, history

function SceneContextProvider(props) {

    [state, setState] = useState({
        URL: {
            base:'http://35.223.234.244:1880/',
            get_scenes: 'get_scenes',
            update_scene: 'update_scene2',
            get_map: 'get_map',
            update_map: 'update_map',
        },
        daylight: 'manana',
        display_map: false,
        require_user_click: true,
        video_loaded: false,
        all_loaded: false,
        dev_mode: false,
        scene_visible: false,
        fetching: false,
        scenes_list: {},
        map_data: {},
        selected_scene: '',
        selected_scene_data: null,
        audioboxes_state: [],
        nav_state: [],
        moveable_element: null,
        
        /* Functions */
        fecthScenesList,
        startScene,
        changeScene,
        updateScenesList,
        updateSceneData,
        setMoveableElement,
        editMoveableData,
        addAudioBox,
        addNavButton,
        toogle_dev_mode,
        activateAudioBox,
        deactivateAudioBox,
        toogleAudioBox,
        activateNavButton,
        toogleNavButton,
        deactivateNavButton,
        disable_require_user_click,
        set_video_loaded,
        addButtonsVereda,
        addButtonsEsquina,
        set_daylight,
        change_display_map,
        updateMapData
    })

    location = useLocation()
    history = useHistory()

    //useEffect(data_receiver, [state.selected_scene])

    return (
        <SceneContext.Provider value={state}>
            {props.children}
        </SceneContext.Provider>
    )
}

/* ------ AUX FUNCTIONS ------ */

async function data_receiver() {
  const scene_zip_data = await fetch('http://www.iowlabs.cl/etqq/zip/' + state.selected_scene + '.zip', { method: 'GET', headers: { 'Content-Type': 'application/zip, application/octet-stream' } })
}

function toogle_dev_mode() {
    deactivateAudioBox()
    setState(s => ({...s, dev_mode: !s.dev_mode, moveable_element: null }))
}

function disable_require_user_click() {
    setState(s => ({...s, require_user_click: false }))
}

function set_video_loaded(video_loaded) {
    setState(s => ({...s, video_loaded }))
    setTimeout(()=>setState(s => ({...s, all_loaded: video_loaded })), 500)
}

function set_daylight(daylight) {
    setState(s => ({...s, daylight }))
}

function change_display_map(b) {
    setState(s => ({...s, display_map: b }))
}

async function fecthScenesList() {
    console.log("STORE: Fetching scenes.")
    setState(s => ({ ...s, fetching: true }))
    let response_scenes = {}
    let response_map = {}

    const __PRODUCTION__ = true

    if(__PRODUCTION__) {
        response_scenes = JSON.parse(JSON.stringify(scenes))
        response_map = JSON.parse(JSON.stringify(map_data))
    } else {
        try {
            response_scenes = await fetch(state.URL.base + state.URL.get_scenes, { method: 'GET', headers: { 'Content-Type': 'application/json' } })
            response_scenes = await response_scenes.json()
        } catch(e) {
            response_scenes = JSON.parse(JSON.stringify(scenes))
        }

        try {
            response_map = await fetch(state.URL.base + state.URL.get_map, { method: 'GET', headers: { 'Content-Type': 'application/json' } })
            response_map = await response_map.json()
        } catch(e) {
            //response_map = JSON.parse(JSON.stringify(map_data))
            response_map = {}
        }
    }

    Object.values(response_scenes).forEach(e => {
      e.AudioBoxes?.forEach(m => m.idd = nanoid())
      e.NavButtons?.forEach(m => m.idd = nanoid())
    });
    
    
    setState(s => ({...s, scenes_list: response_scenes, 'map_data': response_map, fetching: false }))
    console.log("STORE: Scenes arrived.")
    return true
}

async function startScene(name) {
    console.log("STORE: Starting scene.")
    if(name === ''){
      history.push('IntroETQQ')
      return
    }

    //await downloadSceneData()
    
    let data = state.scenes_list[name]
    if(data){
        let audioboxes_state = []
        data.AudioBoxes?.map((d,i) => audioboxes_state.push(false))
        let nav_state = []
        data.NavButton?.map((d,i) => nav_state.push(false))
        let day = data.daylight || state.daylight || ''
        setState(s => ({ ...s, daylight: day, selected_scene: name, selected_scene_data: data, audioboxes_state, nav_state, scene_visible: true }))
        console.log("STORE: Scene " + name + " started.")
    }
}

async function downloadSceneData(name) {
  let scene_zip = {}

  try {
    scene_zip = await fetch('http://www.iowlabs.com/etqq/scenes_media/ME01.zip', { mode: 'no-cors', method: 'GET', headers: { 'Content-Type': 'application/zip, application/octet-stream' }})
    scene_zip = await scene_zip.blob()
    //let objectURL = URL.createObjectURL(scene_zip)
    console.log("zip dowloaded")
    //console.log(objectURL)

    let myReader = new FileReader()
    myReader.onload = function(e){
      console.log(myReader.result)
      /*
      let zip = new JSZip();
      zip.loadAsync(myReader.result).then(()=>{
        console.log("zipzip loaded")
      })
      */
    }
    myReader.readAsArrayBuffer(scene_zip)
    
  } catch(e) {
    console.log(e)
  }
}

function changeScene() {
    console.log("STORE: Scene change detected.")
    setState(s => ({ ...s, scene_visible: false, moveable_element: null, video_loaded: false }))
    deactivateAudioBox()
    
    setTimeout(() => {
        startScene( location.pathname.substring(1) )    
    }, 500)
}

function updateScenesList(scenes_list) {
    console.log("STORE: Scenes list updated.")
    setState(s => ({...s, scenes_list }))
}

function updateSceneData(selected_scene_data) {
    console.log("STORE: Updating scene data.")
    setState(s => ({ ...s, selected_scene_data }))
}

function updateMapData(mapData) {
    console.log("STORE: Map data updated.")
    setState(s => ({...s, 'map_data': mapData }))
}

function setMoveableElement(e) {
    if(state.dev_mode) {
        if(e === null) {
            setState(s => ({ ...s, moveable_element: null }))
        } else {
            e.preventDefault()
            let moveable_element = e.target.classList.contains('selectable') ? e.target : null
            setState(s => ({ ...s, moveable_element }))
        }
    }
}

function editMoveableData(key, x, y, scale) {
    let md = state.map_data
    try {
        let [t ,a, b] = key.split('-')
        let d = false
        if(t === 'audioBox'){
            if (b === 'a') {
                if(x) 
                    state.selected_scene_data.AudioBoxes[a].audio.x = x
                if(y) 
                    state.selected_scene_data.AudioBoxes[a].audio.y = y
            } else {
                a = parseInt(a)
                b = parseInt(b)
                console.log("changing image coords")
                if(x) 
                    state.selected_scene_data.AudioBoxes[a].imgs[b].x = x
                if(y) 
                    state.selected_scene_data.AudioBoxes[a].imgs[b].y = y
                if(scale) 
                    state.selected_scene_data.AudioBoxes[a].imgs[b].transform = scale
            }
        } else if (t === 'navButton') {
            a = parseInt(a)
            b = parseInt(b)
            if(x) 
                state.selected_scene_data.NavButtons[a].imgs[b].x = x
            if(y) 
                state.selected_scene_data.NavButtons[a].imgs[b].y = y
            if(scale) 
                state.selected_scene_data.NavButtons[a].imgs[b].transform = scale
        } else if (t === 'mapButton') {
            a = parseInt(a)
            console.log("index", a)
            md = JSON.parse(JSON.stringify(state.map_data)) 
            if(x) 
                md[state.daylight].nav[a].style['left'] = x
            if(y) 
                md[state.daylight].nav[a].style['top'] = y
            if(scale) 
                md[state.daylight].nav[a].style['transform'] = scale
        } else if (t === 'mapButtonScene') {
            a = parseInt(a)
            console.log("editing")
            console.log(a)
            console.log(x)
            console.log(y)
            d = JSON.parse(JSON.stringify(state.selected_scene_data))
            if(x) d.MapBoxes[a].style['left'] = x
            if(y) d.MapBoxes[a].style['top'] = y
            if(scale) d.MapBoxes[a].style['transform'] = scale
      }
        
        setState(s => ({ ...s, selected_scene_data: JSON.parse(JSON.stringify(d || state.selected_scene_data)), 'map_data': md }))
    } catch(e) {
        console.log(e)
    }    
}

function toogleAudioBox(index) {
    let audioboxes_state = []
    state.audioboxes_state?.map((b,i) => audioboxes_state.push( index === i? !b : false ))

    setState(s => ({ ...s, audioboxes_state }))
}

function activateAudioBox(index) {
    if(state.dev_mode)
        return

    let audioboxes_state = []
    state.audioboxes_state?.map((b,i) => audioboxes_state.push(false))
    audioboxes_state[index] = true

    setState(s => ({ ...s, audioboxes_state }))
}

function deactivateAudioBox() {
    let audioboxes_state = []
    state.audioboxes_state?.map((b,i) => audioboxes_state.push(false))

    setState(s => ({ ...s, audioboxes_state }))
}

function toogleNavButton(index) {
    let nav_state = []
    state.nav_state?.map((b,i) => nav_state.push( index === i? !b : false ))

    setState(s => ({ ...s, nav_state }))
}

function activateNavButton(index) {
    if(state.dev_mode)
        return

    let nav_state = []
    state.nav_state?.map((b,i) => nav_state.push(false))
    nav_state[index] = true

    setState(s => ({ ...s, nav_state }))
}

function deactivateNavButton() {
    let nav_state = []
    state.nav_state?.map((b,i) => nav_state.push(false))

    setState(s => ({ ...s, nav_state }))
}

function addButtonsVereda() {

    let new_data = [
        {
            nav_to: '',
            label: {
              text: 'Avanza por vereda',
              position: 'top',
              x: 0,
              y: 0
            },
            imgs: [
              {
                type: 'main',
                src: 'ETQQ_VN1a-Izq_vereda.png',
                x: 51.87685085514776,
                y: 568.7388917473814,
                transform: '',
                transition: 'opacity 0.4s'
              },
              {
                type: 'hover',
                src: 'ETQQ_VN1a-Izq_vereda-Hover.png',
                x: 51.87685085514776,
                y: 568.7388917473814,
                transform: '',
                transition: 'opacity 0.4s'
              }
            ]
        },
        {
        nav_to: '',
        label: {
            text: '',
            position: 'top',
            x: 0,
            y: 0
        },
        imgs: [
                {
                    type: 'main',
                    src: 'ETQQ_VN1a-Der_vereda.png',
                    x: 1163.7117817124672,
                    y: 568.7388917473814,
                    transform: '',
                    transition: 'opacity 0.4s'
                },
                {
                    type: 'hover',
                    src: 'ETQQ_VN1a-Der_vereda-Hover.png',
                    x: 1163.7117817124672,
                    y: 568.7388917473814,
                    transform: '',
                    transition: 'opacity 0.4s'
                }
            ]
        },
        {
            nav_to: '',
            label: {
                text: 'Cruza a la vereda',
                position: 'top',
                x: 0,
                y: 0
            },
            imgs: [
                {
                    type: 'main',
                    src: 'ETQQ_VN1a-OtraVereda.png',
                    x: 588.8850068411821,
                    y: 600.9656872862131,
                    transform: 'matrix(1,0,0,1,0,0) scale(0.7979618433289376, 0.7979618433289376) ',
                    transition: 'opacity 0.4s'
                },
                {
                    type: 'hover',
                    src: 'ETQQ_VN1a-OtraVereda-Hover.png',
                    x: 588.8850068411821,
                    y: 600.9656872862131,
                    transform: 'matrix(1,0,0,1,0,0) scale(0.7979618433289376, 0.7979618433289376) ',
                    transition: 'opacity 0.4s'
                }
            ]
        }
    ]

    if(!state.selected_scene_data.NavButtons) 
        state.selected_scene_data.NavButtons = []

    state.selected_scene_data.NavButtons.push(...new_data)
    console.log(state.selected_scene_data)
    
    setState(s => ({ ...s, selected_scene_data: state.selected_scene_data }))
}

function addButtonsEsquina() {

    let new_data = [
        {
          nav_to: '',
          label: {
            text: '',
            position: 'top',
            x: 0,
            y: 0
          },
          imgs: [
            {
              type: 'main',
              src: 'ETQQ_ME01-Avanzar.png',
              x: 665.781698961872,
              y: 484.8013010381279,
              transform: '',
              transition: 'opacity 0.4s'
            },
            {
              type: 'hover',
              src: 'ETQQ_ME01-Avanzar-Hover.png',
              x: 665.781698961872,
              y: 484.8013010381279,
              transform: '',
              transition: 'opacity 0.4s'
            }
          ]
        },
        {
          nav_to: '',
          label: {
            text: '',
            position: 'top',
            x: 0,
            y: 0
          },
          imgs: [
            {
              type: 'main',
              src: 'ETQQ_ME01-Derecha.png',
              x: 859.4317340152968,
              y: 525.4361958778538,
              transform: '',
              transition: 'opacity 0.4s'
            },
            {
              type: 'hover',
              src: 'ETQQ_ME01-Derecha-Hover.png',
              x: 859.4317340152968,
              y: 525.4361958778538,
              transform: '',
              transition: 'opacity 0.4s'
            }
          ]
        },
        {
          nav_to: '',
          label: {
            text: '',
            position: 'top',
            x: 0,
            y: 0
          },
          imgs: [
            {
              type: 'main',
              src: 'ETQQ_ME01-Izquierda.png',
              x: 468.6437134045662,
              y: 527.3883567022832,
              transform: '',
              transition: 'opacity 0.4s'
            },
            {
              type: 'hover',
              src: 'ETQQ_ME01-Izquierda-Hover.png',
              x: 468.6437134045662,
              y: 527.3883567022832,
              transform: '',
              transition: 'opacity 0.4s'
            }
          ]
        },
        {
          nav_to: '',
          label: {
            text: '',
            position: 'top',
            x: 0,
            y: 0
          },
          imgs: [
            {
              type: 'main',
              src: 'ETQQ_ME02-RetrocederE02.png',
              x: 640.5268451917785,
              y: 587.1496080924636,
              transform: '',
              transition: 'opacity 0.4s'
            },
            {
              type: 'hover',
              src: 'ETQQ_ME02-RetrocederE02-Hover.png',
              x: 640.5268451917785,
              y: 587.1496080924636,
              transform: '',
              transition: 'opacity 0.4s'
            }
          ]
        }
      ]

    if(!state.selected_scene_data.NavButtons) 
        state.selected_scene_data.NavButtons = []

    state.selected_scene_data.NavButtons.push(...new_data)
    console.log(state.selected_scene_data)
    
    setState(s => ({ ...s, selected_scene_data: state.selected_scene_data }))
}

function addAudioBox() {
    let ab = {
        audio: {
          src: '',
          x: 900.104,
          y: 500.967
        },
        imgs: [
          {
            type: 'main',
            src: '',
            x: 0,
            y: 346.99902750872855,
            transform: '',
            hide: false
          },
          {
            type: 'hover',
            src: '',
            x: 0,
            y: 0,
            transform: '',
            transition: 'opacity 0.4s'
          }
        ]
      }

    if(!state.selected_scene_data.AudioBoxes)
        state.selected_scene_data.AudioBoxes = []

    state.selected_scene_data.AudioBoxes.push(ab)

    setState(s => ({ ...s, selected_scene_data: state.selected_scene_data }))
}

function addNavButton() {
    let ab = {
        nav_to: '',
        imgs: [
          {
            type: 'main',
            src: '',
            x: 172.32865635689345,
            y: 304.5243591077663,
            transform: '',
            transition: 'opacity 0.4s',
            hide: false
          },
          {
            type: 'main',
            src: '',
            x: 174.68857041011682,
            y: 430.81978513305836,
            transform: ' ',
            transition: 'opacity 0.4s',
            hide: false
          },
          {
            type: 'hover',
            src: '',
            x: 158,
            y: 0,
            transform: '',
            transition: 'opacity 0.4s'
          }
        ]
      }

    if(!state.selected_scene_data.NavButtons)
        state.selected_scene_data.NavButtons = []

    state.selected_scene_data.NavButtons.push(ab)
    
    setState(s => ({ ...s, selected_scene_data: state.selected_scene_data }))
}


export { SceneContext, SceneContextProvider }
